import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  padding: 0;
  box-sizing: border-box;

  .hidden {
    display: none;
  }

  @media (min-width: 768px) {
    padding: 0 4px;
  }
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (min-width: 600px) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
`;

const Title = styled.h2`
  font-size: 20px;
  margin: 0;
  cursor: default;
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const Content = styled.main`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const BlockContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 20px 0px;
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const FiltersBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (min-width: 600px) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
`;

const ListArea = styled.section`
  min-height: 100px;
  width: 100%;
`;

const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  min-width: 0;
`;

const Error = styled.p`
  color: ${(props) => props.theme.colors.red};
  margin: 0;
`;

/** Kept for backwards compatibility; prefer toast for upload messages. */
const UploadMessage = styled.p`
  margin: 0;
  font-size: 14px;
`;

export default {
  Wrapper,
  Header,
  Title,
  Actions,
  Content,
  BlockContainer,
  RowContainer,
  FiltersBar,
  ListArea,
  CardList,
  Error,
  UploadMessage,
};
